/**
 * Relay for Checkout
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const CheckoutPageQuery = graphql`
  query checkout_Query($country_code: String, $subdivision_code: String) {
    viewer{
      ...checkout_viewer
      stripe {
        public_key
      }
    }
  }
`;

export const checkoutFragment = graphql`
  fragment checkout_viewer on Viewer {
    checkout(country_code: $country_code, subdivision_code: $subdivision_code){
      ...orderNode @relay(mask: false)
    }
    profile {
      ...profile @relay(mask: false)
    }
    company_types{
      edges{
        node{
          id
          name
        }
      }
    }
    representative_roles{
      edges{
        node{
          id
          name
        }
      }
    }
    selected_currency
  }
`;

export const CheckoutAttributesQuery = graphql`
  query checkoutAttributes_Query {
    viewer {
      ...checkoutAttributes_viewer
    }
  }
`;

export const checkoutAttributesFragment = graphql`
  fragment checkoutAttributes_viewer on Viewer {
    company_types{
      edges{
        node{
          id
          name
        }
      }
    }
    representative_roles{
      edges{
        node{
          id
          name
        }
      }
    }
  }
`;

export const AddPromoCodeMutation = graphql`
  mutation checkoutAddPromoCode_Mutation($input: AddPromoCodeInput!, $country_code: String, $subdivision_code: String) {
    addPromoCode(input: $input) {
      checkout(country_code: $country_code, subdivision_code: $subdivision_code){
        ...orderNode @relay(mask: false)
      }
    }
  }
`;

export const DeletePromoCodeMutation = graphql`
  mutation checkoutDeletePromoCode_Mutation(
    $input: DeletePromoCodeInput!,
    $country_code: String,
    $subdivision_code: String,
  ) {
    deletePromoCode(input: $input) {
      checkout(country_code: $country_code, subdivision_code: $subdivision_code){
        ...orderNode @relay(mask: false)
      }
    }
  }
`;

export const PlaceOrderMutation = graphql`
  mutation checkoutPlaceOrder_Mutation($input: PlaceOrderInput!) {
    placeOrder(input: $input) {
      order{
        ...orderNode @relay(mask: false)
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/checkout.ts